import { render, staticRenderFns } from "./TemplatedItems.vue?vue&type=template&id=7f4dfa2d&"
import script from "./TemplatedItems.vue?vue&type=script&lang=js&"
export * from "./TemplatedItems.vue?vue&type=script&lang=js&"
import style0 from "./TemplatedItems.vue?vue&type=style&index=0&id=7f4dfa2d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports